import * as React from 'react';
import './name-and-period.scss';
import DatePicker from './date-picker';
import { Field } from '@teamsnap/teamsnap-ui';
import { SeasonGuideContext } from './season-guide';

const NameAndPeriod = () => {
  const { season, setSeason } = React.useContext(SeasonGuideContext)
  const { start, end, setDatesLater } = season

  return (
    <>
      <Field
        data-testid="season-guide-name"
        type="text"
        name="season name"
        formFieldProps={{
          size: 'large',
          placeholder: 'Spring 2022',
          inputProps: {
            value: season.name,
            onChange: (e) => setSeason({ name: e.target.value }),
          },
        }}
      />

      <h2 className="u-spaceTopLg u-padTopLg">When does the season start and end?</h2>

      <div className="Grid">
        <div className="Grid-cell">
          <div className="season-guide-checkbox-wrapper u-spaceEndsMd u-size11of24">
            <Field
              type="checkbox"
              data-testid="season-guide-date-checkbox"
              name="showDate"
              formFieldProps={{
                text: 'Set dates later',
                checked: setDatesLater,
                onClick: () => setSeason({ setDatesLater: !setDatesLater }),
              }}
            />
          </div>
        </div>
        { !setDatesLater && <DatePicker start={start} end={end} setDates={setSeason} /> }
      </div>
    </>
  )
}

export default NameAndPeriod;
